import { Properties } from "../model/model"

export class Page {
  constructor(
    readonly pagePath: string = "",
    readonly host: string = "",
    readonly hostname: string = "",
    readonly url: string = "",
    readonly referrer: string = "",
    readonly queryParameter: string = "",
    readonly protocol: string = "",
    /** page name */
    readonly pageName: string = "",
    /** page properties */
    readonly properties: Properties = {}
  ) {}

  isEquals(other: Page): boolean {
    return this.url === other.url
  }

  static createWithCurrentPage(pageName?: string, properties?: Properties): Page {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return new Page()
    }

    return new Page(
      window.location.pathname,
      window.location.host,
      window.location.hostname,
      window.location.href,
      window.document.referrer,
      window.location.search,
      window.location.protocol,
      pageName ?? window.document.title,
      properties ?? {}
    )
  }
}
